import { Component, input } from '@angular/core';

/**
 * Brújula hexagonal de las páginas de error (motivo de marca).
 * La aguja narra el estado:
 * - `search`: oscila ±14° (404, buscando).
 * - `fallen`: caída a 137°, apagada (500).
 * - `spin`:   gira en bucle (mantenimiento).
 * - `clock`:  la brújula se vuelve reloj (enlace caducado).
 */
export type CompassMode = 'search' | 'fallen' | 'spin' | 'clock';

@Component({
  selector: 'app-compass-hex',
  standalone: true,
  templateUrl: './compass-hex.component.html',
  styleUrl: './compass-hex.component.scss',
})
export class CompassHexComponent {
  mode = input<CompassMode>('search');
}
